var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.646 30.192a14.016 14.016 0 0 0-4.155-9.808 14 14 0 0 0-9.848-4.049h-.374v-.425c0-3.716-1.475-7.28-4.102-9.908a14 14 0 0 0-9.902-4.104h-22.186a37.755 37.755 0 0 0-26.468 10.799 37.035 37.035 0 0 0-10.134 17.355H38.458c-1.65-.001-3.287.29-4.836.86a14.005 14.005 0 0 0-9.564 13.287v99.688a14.002 14.002 0 0 0 14.004 14.011h148.276c3.714 0 7.276-1.476 9.902-4.103a14.014 14.014 0 0 0 4.102-9.908V44.195a14.016 14.016 0 0 0-3.995-9.795 14.002 14.002 0 0 0-9.701-4.208Z",
    fill: "#FF7051",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.514 140.862a12.924 12.924 0 0 1 12.603-10.032h61.421v13.054h-74.136v-.131c0-.53-.033-1.061-.098-1.588.021-.23.054-.454.098-.672.018-.215.06-.42.112-.631Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.29 142.165c.066.527.098 1.058.098 1.588v.131h-74.14V130.83h61.219a12.924 12.924 0 0 1 12.823 11.335Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.247 44.193v99.693h148.277V44.193h-13.565m-60.569 98.906V37.998",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.101 30.348h13.728v89.015h-42.534a17.774 17.774 0 0 0-12.573 5.211 17.795 17.795 0 0 0-5.207 12.579v5.946",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.452 106.699h-22.187c-12.86 0-23.75 10.429-23.75 23.297v2.419m45.937-116.507h-22.187c-12.86 0-23.75 10.434-23.75 23.301v2.415m45.937-25.519V106.7",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.433 32.223h-2.581a16.407 16.407 0 0 0-11.602 4.811 16.426 16.426 0 0 0-4.806 11.61v4.55",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.433 41.326h-2.581c-4.351 0-8.525 1.73-11.602 4.809a16.422 16.422 0 0 0-4.806 11.608v4.55m18.989 17.408h-2.581a16.407 16.407 0 0 0-11.602 4.812 16.426 16.426 0 0 0-4.806 11.61v4.544",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.435 88.797h-2.581a16.408 16.408 0 0 0-11.597 4.815 16.426 16.426 0 0 0-4.802 11.606v4.549m18.98-59.74h-2.581a16.407 16.407 0 0 0-11.598 4.817 16.428 16.428 0 0 0-4.801 11.61v4.544m-73.81 59.832h60.823a12.923 12.923 0 0 1 12.92 12.923",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185.932 130.83h-60.813a12.92 12.92 0 0 0-12.604 10.032 7.49 7.49 0 0 0-.126.631c-.032.215-.074.467-.098.672a11.883 11.883 0 0 0-.102 1.588M38.645 44.059h60.823a12.913 12.913 0 0 1 11.937 7.976c.649 1.569.983 3.25.983 4.947m-14.17 18.462v29.134H48.663V54.996h49.555v20.448Zm-49.882 38.31h38.487",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.794 95.294s4.126-17.925 13.07-17.21c6.591.527 4.201 8.523 10.545 7.911 8.173-.789 3.786-15.114 12.916-18.462 8.636-3.162 12.655 7.912 12.655 7.912",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.fd73126035b8ebc7679225a7068f53fc.svg";
export { ForwardRef as ReactComponent };